import { CheckCircle2, Circle, Video, Wallet, Flag, RotateCcw } from "lucide-react";

/**
 * Booking timeline showing: Reserveret → Betalt → Konsultation → Afsluttet
 * If the booking is refunded, a fifth "Refunderet" step is highlighted instead of Afsluttet.
 */
export default function BookingTimeline({ booking, compact = false }) {
  if (!booking) return null;
  const paid = ["paid", "paid_mock", "refunded"].includes(booking.payment_status);
  const started = !!booking.started_at || booking.status === "started";
  const completed = booking.status === "completed";
  const refunded = booking.payment_status === "refunded" || booking.status === "cancelled";

  const steps = [
    { key: "reserved", label: "Reserveret", icon: Flag, done: true },
    { key: "paid", label: "Betalt", icon: Wallet, done: paid },
    { key: "consult", label: "Konsultation", icon: Video, done: started },
    refunded
      ? { key: "refunded", label: "Refunderet", icon: RotateCcw, done: true, warn: true }
      : { key: "done", label: "Afsluttet", icon: CheckCircle2, done: completed },
  ];

  return (
    <div className={`rounded-xl border border-brand-line bg-white ${compact ? "p-2.5" : "p-3.5"}`} data-testid={`booking-timeline-${booking.id}`}>
      <div className="flex items-center justify-between gap-2">
        {steps.map((s, i) => {
          const Icon = s.done ? s.icon : Circle;
          const active = s.done;
          const isNext = !active && steps.slice(0, i).every((x) => x.done);
          const color = s.warn
            ? "text-[#B0561D] bg-[#FDF3EA] border-[#F3D9C1]"
            : active
              ? "text-[#166534] bg-brand-soft border-brand-line-strong"
              : isNext
                ? "text-brand-green bg-brand-wash border-brand-line-strong animate-pulse"
                : "text-brand-muted bg-brand-wash border-brand-line";
          return (
            <div key={s.key} className="flex-1 flex items-center gap-1.5 min-w-0" data-testid={`timeline-step-${s.key}`}>
              <div className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center ${color}`}>
                <Icon size={13}/>
              </div>
              <div className="min-w-0 flex-1">
                <div className={`text-[11px] font-medium truncate ${active ? "text-brand-ink" : "text-brand-muted"}`}>
                  {s.label}
                </div>
              </div>
              {i < steps.length - 1 && (
                <div className={`hidden sm:block h-0.5 w-4 rounded-full flex-shrink-0 ${steps[i + 1].done ? "bg-brand-green" : "bg-brand-line"}`}/>
              )}
            </div>
          );
        })}
      </div>
      {refunded && !compact && (
        <div className="mt-2 text-[11px] text-[#B0561D]">Betalingen er refunderet. Beløbet er tilbageført til dit kort.</div>
      )}
    </div>
  );
}

